import React from 'react';

const FormData = React.createContext({});

export const FormDataProvider = FormData.Provider;
export const FormDataConsumer = FormData.Consumer;

export default FormData;
